import { useState, useEffect } from "react";
import Modal from "react-modal";
import "./style.css";
import { toast } from 'react-hot-toast';

import Img1 from "../../assets/saldos/1.png";
import Img2 from "../../assets/saldos/2.png";
import Img3 from "../../assets/saldos/3.png";

import Sidebar from "../../componente/sidebar/index.jsx";
import PageHeader from "../../componente/topbar/index.jsx";

import { useAppContext } from "../../pages/context/AppContext.jsx";
import { useCrud } from "../../hooks/useCrud";

Modal.setAppElement("#root");

function Saldo() {

  const { codusuario } = useAppContext();

  const imagens = {
    0: { src: Img1, tipo: "Carteira" },
    1: { src: Img2, tipo: "Banco" },
    2: { src: Img3, tipo: "Poupança/Investimento" }
  };

  const [sidebarAberto, setSidebarAberto] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editando, setEditando] = useState(null);

  const {
    dados: saldos,
    loading,
    error,
    listar,
    buscarUm,
    criar,
    editar,
    excluir
  } = useCrud({
    rotaLista: "v1/saldo",
    rotaUm: "v1/saldoum"
  });

  useEffect(() => {
    listar({ codusuario });
  }, []);

  const [form, setForm] = useState({
    indexsaldo: 1,
    saldo: "",
    diavencimentocartao: 0,
    tipo: "Carteira"
  });

  const formatar = (v) =>
    v.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL"
    });

  const abrirModal = async (item = null) => {
    if (item) {
      const dados = await buscarUm({
        codsaldo: item.codsaldo,
        codusuario
      });
      if (!dados) {
        toast.error("Erro ao carregar dados");
        return;
      }
      setEditando(dados.codsaldo);
      setForm({
        codsaldo: dados.codsaldo,
        indexsaldo: dados.indexsaldo,
        saldo: dados.saldo,
        diavencimentocartao: dados.diavencimentocartao,
        tipo: dados.tipo
      });
    } else {
      setEditando(null);
      setForm({
        indexsaldo: 0,
        saldo: "",
        diavencimentocartao: 0,
        tipo: "Carteira"
      });
    }
    setModalOpen(true);
  };

  const salvar = async () => {

    const dt1 = new Date();

    const date1 =
      dt1.getFullYear() +
      "-" +
      (dt1.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      dt1.getDate().toString().padStart(2, "0");

    const time1 =
      dt1.getHours().toString().padStart(2, "0") +
      ":" +
      dt1.getMinutes().toString().padStart(2, "0");

    if (!form.saldo) {
      toast.error("Informe o nome do saldo");
      return;
    }

    if (editando) {

      await editar({
        dtalteracao: `${date1}T${time1}`,
        codsaldo: editando,
        indexsaldo: form.indexsaldo,
        saldo: form.saldo,
        diavencimentocartao:
          form.indexsaldo === 1
            ? Number(form.diavencimentocartao)
            : 0,
        tipo: form.tipo
      });

    } else {

      await criar({
        dtalteracao: `${date1}T${time1}`,
        codusuario,
        indexsaldo: form.indexsaldo,
        saldo: form.saldo,
        diavencimentocartao:
          form.indexsaldo === 1
            ? Number(form.diavencimentocartao)
            : 0,
        tipo: form.tipo
      });

    }

    setModalOpen(false);

  };

  const excluirSaldo = async (codsaldo) => {

    if (!window.confirm("Deseja realmente excluir este saldo?")) return;

    await excluir({
      codsaldo,
      codusuario
    });

  };

  return (
    <>
      <PageHeader
        titulo="Saldos"
        subtitulo="Gerencie seus saldos financeiros"
        abrirMenu={() => setSidebarAberto(true)}

        botaoAdicionar
        textoAdicionar="Novo Saldo"
        onAdicionar={() => abrirModal()}
      />

      <div className="saldo-container">

        {/* SIDEBAR */}
        <Sidebar
          aberto={sidebarAberto}
          fechar={() => setSidebarAberto(false)}
        />

        <div className="saldo-wrapper">

          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}

          {/* LISTA */}
          {loading ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Carregando...</span>
              </div>
            </div>
          ) : (

            <div className="saldo-list">

              {saldos.map((s) => {

                const receita = s.valreceita ?? 0;
                const despesa = s.valdespesa ?? 0;
                const saldoFinal = receita - despesa;

                return (

                  <div
                    key={s.codsaldo}
                    className="saldo-card"
                    onClick={() => abrirModal(s)}
                  >

                    <div className="saldo-top-row">

                      <div className="saldo-left">

                        <img src={imagens[s.indexsaldo].src} alt="" />

                        <div>
                          <strong>{s.saldo}</strong>
                          <small>{s.tipo}</small>
                        </div>

                      </div>

                      <button
                        className="btn-delete"
                        onClick={(e) => {
                          e.stopPropagation();
                          excluirSaldo(s.codsaldo);
                        }}
                      >
                        Excluir
                      </button>

                    </div>

                    <div className="saldo-values">

                      <div>
                        <span>Receitas</span>
                        <strong className="receita">
                          {formatar(s.valreceita)}
                        </strong>
                      </div>

                      <div>
                        <span>Despesas</span>
                        <strong className="despesa">
                          {formatar(s.valdespesa)}
                        </strong>
                      </div>

                      <div>
                        <span>Saldo</span>
                        <strong
                          className={
                            saldoFinal >= 0
                              ? "saldo-positivo"
                              : "saldo-negativo"
                          }
                        >
                          {formatar(saldoFinal)}
                        </strong>
                      </div>

                    </div>

                  </div>

                );

              })}

            </div>

          )}

          {/* MODAL */}
          <Modal
            isOpen={modalOpen}
            onRequestClose={() => setModalOpen(false)}
            className="modal-content"
            overlayClassName="modal-overlay"
          >

            <div className="modal-header">
              <h3>{editando ? "Editar Saldo" : "Novo Saldo"}</h3>
            </div>

            <div className="modal-body">

              <div className="modal-imagens">

                {[0, 1, 2].map(i => (

                  <img
                    key={i}
                    src={imagens[i].src}
                    alt=""
                    className={form.indexsaldo === i ? "ativo" : ""}
                    onClick={() =>
                      setForm({
                        ...form,
                        indexsaldo: i,
                        tipo: imagens[i].tipo,
                        diavencimentocartao:
                          i === 1
                            ? form.diavencimentocartao
                            : 0
                      })
                    }
                  />

                ))}

              </div>

              {form.indexsaldo === 1 && (
                <input
                  type="number"
                  placeholder="Dia do vencimento"
                  value={form.diavencimentocartao}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      diavencimentocartao: Number(e.target.value)
                    })
                  }
                />
              )}


              <input
                type="text"
                placeholder="Nome do saldo"
                value={form.saldo}
                onChange={(e) =>
                  setForm({ ...form, saldo: e.target.value })
                }
              />

            </div>

            <div className="modal-footer">

              <button
                className="btn-cancelar"
                onClick={() => setModalOpen(false)}
              >
                Cancelar
              </button>

              <button
                className="btn-salvar"
                onClick={salvar}
              >
                Salvar
              </button>

            </div>

          </Modal>

        </div>

      </div>
    </>
  );
}

export default Saldo;